export default __webpack_public_path__ + "static/media/IMG_5004-min.721c8ab5.JPG";